import React from 'react';
import { common } from '@kurtosys/ksys-app-template';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';

import { IIconInputConfiguration, IIconInputProps, IIconInputState } from './models/index.js';
import ClearButton from './styledComponents/ClearButton.js';
import ErrorWrapper from './styledComponents/ErrorWrapper.js';
import IconComponent from './styledComponents/IconComponent.js';
import IconWrapper from './styledComponents/IconWrapper.js';
import InputComponent from './styledComponents/InputComponent.js';
import InputPill from './styledComponents/InputPill.js';
import Label from './styledComponents/Label.js';
import RightContent from './styledComponents/RightContent.js';
import StandardWrapper from './styledComponents/StandardWrapper.js';
import Wrapper from './styledComponents/Wrapper.js';
import { ICON_INPUT_CATEGORY_KEY, ICON_INPUT_COMPONENT_KEY } from './IconInput.meta.js';

export class IconInput extends ComponentBase<IIconInputProps, IIconInputState, IIconInputConfiguration> {
	categoryKey = ICON_INPUT_CATEGORY_KEY;
	componentKey = ICON_INPUT_COMPONENT_KEY;
	iconInputIconKey = 'base.documentDownload.icon';
	shouldFocus = false;
	labelId = `icon_input_${common.commonUtils.generateGuid()}`;

	constructor(props: IIconInputProps) {
		super(props);
	}
	render() {
		const {
			className,
			iconProps,
			onFocus,
			onKeyDown,
			onChange,
			onClear,
			showClear = false,
			hasError,
			pillProps,
			label = {},
			...props
		} = this.props;

		const { value = this.props.placeholder, hideLabel = true } = label;

		const autoFocusEndOfInput = (event: React.FocusEvent<HTMLInputElement>) => {
			const value = event.target.value;
			event.target.value = '';
			event.target.value = value;
		};

		// eslint-disable-next-line @typescript-eslint/naming-convention
		const StatusWrapper = hasError ? ErrorWrapper : StandardWrapper;
		if (this.shouldFocus) {
			Object.assign(props, { focus: this.shouldFocus });
			this.shouldFocus = false;
		}

		const pillPosition = pillProps && (pillProps.pillPosition || 'right');
		const showClearButton = showClear && this.props.value;

		return (
			<Wrapper className={className}>
				<Label id={this.labelId} value={value} hideLabel={hideLabel} />
				<StatusWrapper>
					<IconWrapper>
						<IconComponent {...iconProps} />
					</IconWrapper>
					{pillPosition === 'left' && <InputPill {...pillProps} data-placement={'left'} />}
					<InputComponent
						{...props}
						aria-labelledby={this.labelId}
						onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
							if (hasError) {
								this.shouldFocus = true;
							}
							if (typeof onChange === 'function') {
								onChange(event);
							}
						}}
						onFocus={(event: React.FocusEvent<HTMLInputElement>) => {
							autoFocusEndOfInput(event);
							if (typeof onFocus === 'function') {
								onFocus(event);
							}
						}}
						onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
							if (event.key === 'Enter' && typeof onKeyDown === 'function') {
								onKeyDown(event);
							}
						}}
					/>
					<RightContent>
						{pillPosition === 'right' && <InputPill {...pillProps} />}
						{showClearButton && (
							<ClearButton onClick={onClear} iconProps={{ asset: 'base.iconInput.clear' }} />
						)}
					</RightContent>
				</StatusWrapper>
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(observer(IconInput), ICON_INPUT_CATEGORY_KEY, ICON_INPUT_COMPONENT_KEY);
